<template>
  <CRow>
    <CCol col="12" md="7">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/society.svg" style="width:20px" /> Society
          </p>
        </CCardHeader>
      <br>
        <div class="row">
  <!-- <div clsass="col-sm-4">   <h5> Sepices</h5></div> -->
  <div class="col-sm-6" >
   &nbsp;&nbsp;&nbsp; <Vselect :options="saveSocietylist" v-model="soceityName1"   searchable  style="margin-left:10px"/>  
  </div>
  <div class="col-sm-2">
    <CButton color="info" @click="go">
            GO
              </CButton>
  </div>

</div>

        <CCardBody>
          <CDataTable
            :items="societyItem1"
            :fields="fields"
            table-filter
            items-per-page-select
            :items-per-page="5"
            pagination
            clickable-rows
            hover
            @row-clicked="rowClicked"
            caption="Breed"
          />
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="6" md="5">
      <CCard>
        <CCardBody>
          <CTabs add-tab-classes="mt-1">
            <CTab>
              <template slot="title">
                <img src="img/society.svg" style="width:20px" />
                {{tabs[0]}}
              </template>
              <!-- <CCard> -->
                <!-- <CCardBody> -->
                  <CForm>
                    <CInput
                      label="Society Code"
                      horizontal
                      autocomplete="name"
                      name="soceityCode"
                      id="soceityCode"
                      required
                      v-model="soceityCode"
                    />

                    <CInput
                      label="Society Name"
                      horizontal
                      autocomplete="name"
                      name="soceityName"
                      id="soceityName"
                      required
                      v-model="soceityName"
                    />
                    <CInput
                      label="Contact Person"
                      horizontal
                      autocomplete="name"
                      name="contactPerson"
                      id="contactPerson"
                      required
                      v-model="contactPerson"
                    />

                    <CInput
                      label="Mobile No"
                      horizontal
                      autocomplete="name"
                      name="mobileNumber"
                      id="mobileNumber"
                      required
                      v-model="mobileNumber"
                    />
                    <CInput
                      label="Email"
                      horizontal
                      autocomplete="name"
                      name="Email"
                      id="Email"
                      required
                      v-model="email"
                    />
                    <CInput
                      label="Week Day"
                      horizontal
                      autocomplete="name"
                      name="weekday"
                      id="weekday"
                      required
                      v-model="weekday"
                    />
                    <CInput
                      label="	
Form Time"
                      horizontal
                      autocomplete="name"
                      name="fromTime"
                      id="fromTime"
                      required
                      v-model="fromTime"
                    />
                    <CInput
                      label="	
To Time"
                      horizontal
                      autocomplete="name"
                      name="toTime"
                      id="toTime"
                      required
                      v-model="toTime"
                    />

                           <CInput
                      label="lattitude"
                      horizontal
                      autocomplete="name"
                      name="toTime"
                      id="toTime"
                      required
                      v-model="lattitude"
                    />

                           <CInput
                      label="	
longitude"
                      horizontal
                      autocomplete="name"
                      name="toTime"
                      id="toTime"
                      required
                      v-model="longitude"
                    />

                    <CRow>
                      <CCol sm="3">
                        <h5 style="font-size:15px">Status</h5>
                      </CCol>
                      <CCol sm="3">
                        <CSwitch
                          class="mx-1"
                          color="primary"
                          name="suspend"
                          id="suspend"
                          required
                          checked
                          variant="opposite"
                          v-model="suspend"
                          style="width:50px;float:left !important"
                          shape="pill"
                          v-bind="labelTxt"
                        />
                   <!-- <CInput
                    type="checkbox" 
                   
                      horizontal
                      autocomplete="name"
                      name="fromTime"
                      id="fromTime"
                      required
                      v-model="suspend"
                    /> -->
                      </CCol>
                      <br>
                      <br>
                        <CCardFooter>
                  <CButton color="info" style="width:100px" v-if="addButton" @click="addSociety">
                    <CIcon name="cilPencil" />&nbsp;Add
                  </CButton>&nbsp;
                  <CButton
                    color="success"
                    style="width:100px"
                    v-if="saveButton"
                    @click="updateRoute"
                  >
                    <CIcon name="cilCheck" />&nbsp;Save
                  </CButton>&nbsp;
                  <CButton
                    color="danger"
                    style="width:100px"
                    v-if="deleteButton"
                    @click="deleteRoute"
                  >
                    <CIcon name="cilXCircle" />&nbsp;Delete
                  </CButton>&nbsp;
                  <CButton
                    color="success"
                    style="width:100px"
                    v-if="EditsaveButton"
                    @click="addSociety"
                  >
                    <CIcon name="cilCheck" />&nbsp;Save
                  </CButton>&nbsp;
                  <CButton
                    color="secondary"
                    style="width:100px"
                    v-if="cancelButton"
                    @click="CancelRoute"
                  >
                    <CIcon name="cilWarning" />&nbsp;Cancel
                  </CButton>&nbsp;
                  <CButton color="info" v-if="addnewButton" @click="addRouteplus">
                    <CIcon name="cilPencil" />&nbsp;Add New
                  </CButton>
                </CCardFooter>
                    </CRow>
                    
                  </CForm>
                <!-- </CCardBody> -->
              
              <!-- </CCard> -->
            </CTab>
            <CTab>
              <template slot="title">
                <img src="img/location.svg" style="width:20px" />
                {{tabs[1]}}
              </template>
              <div class="row">
                 <div class="col-sm-6">
                  <CInput label="address" name="address" v-model="physicaladdress" @change="getAddress()" />
                </div>
                <div class="col-sm-6">
                 
    
                  <CInput label="Latitute" name="lattitude"  />
                </div>
                <div class="col-sm-6">
                  <CInput label="Longtitude" name="longitude" id="longitude" required />
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                   <LocationMap @on-loactionselect="setlatlng"></LocationMap>
                  <h5>Enter the Latitude and Longtitude</h5>
            
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <br />
                  <CButton color="info" style="width:100px">
                    <CIcon name="cilPencil" />&nbsp;Add
                  </CButton>
                </div>
                <div class="col-sm-4">
                  <br />
                  <CButton color="success" style="width:100px">
                    <CIcon name="cilCheck" />&nbsp;Save
                  </CButton>
                </div>
                <div class="col-sm-4">
                  <br />
                  <CButton color="danger" style="width:100px">
                    <CIcon name="cilXCircle" />&nbsp;Delete
                  </CButton>
                </div>
              </div>
            </CTab>
          </CTabs>

          <CRow>
            <CCol sm="6"></CCol>
            <CCol sm="1"></CCol>
            <CCol sm="4" style="text-align:center">
              <br />
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { APIService } from "../../../apiservice.js";
import CTableWrapper from "../../tables/Table";
import Locationmap from "@/components";
import Swal from "sweetalert2";
import { Vselect } from "@/components";
export default {
  components: { CTableWrapper,Locationmap,Vselect },

  data() {
    return {
         latitude: 0,
        longitude: 0,
      societyItem:[],
       societyItem1:[],
      societyedit:[],
      saveSocietylist:[],
      physicaladdress:"",
      soceityCode: null,
      soceityName: "",
      soceityName1:null,
      contactPerson: "",
      mobileNumber: "",
      email: "",
      weekday: "",
      fromTime: "",
      toTime: "",
      longitude:"",
      lattitude:"",
      suspend: true,
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      tabs: ["Society Details", "Map"],
      labelTxt: {
        labelOn: "yes",
        labelOff: "no"
      },
      fields: [
        {
          key: "soceityCode",
          sortable: true
        },
        {
          key: "soceityName",
          sortable: true
        },
        {
          key: "email",
          sortable: true
        },
        {
          key: "mobileNumber",
          sortable: true
        },
        {
          key: "weekday",
          sortable: true
        },

        {
          key: "fromTime",
          sortable: true
        },
        {
          key: "weekday",
          sortable: true
        },
        {
          key: "fromTime",
          sortable: true
        },
        {
          key: "toTime",
          sortable: true
        },

        {
          key: "lattitude",
          sortable: true
        },
        {
          key: "longitude",
          sortable: true
        },
         {
          key: "suspend",
          sortable: true
        }
      ],
      
    };
  },
  methods: 
  {
      go(){
  this.societyItem1 = this.societyItem.filter( n=>
 n.soceityName == this.soceityName1 )
  },
         setlatlng(location) {
      let self = this;
       this.lattitude = location.lat;
      this.longitude = location.lng;
    },
    getAddress() {
      let self = this;
      if (this.physicaladdress) {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode(
          { address: this.physicaladdress },
          (results, status) => {
            if (status === "OK") {
              let value = {
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng()
              };
         
            //  this.user.physicaladdress.latitude = results[0].geometry.location.lat();
            // this.user.physicaladdress.longitude = results[0].geometry.location.lng();
              this.$root.$emit("openCustomerMap", value);
            }
          }
        );
      }
    },
    getSocietyList() {
      let sus = [];
      APIService.societyList().then(res => {
        if (res.status == 200) {
          this.societyItem = res.data;
           this.societyItem1 = res.data;

          this.soceityCode =  this.societyItem[0].soceityCode;
      this.soceityName = this.societyItem[0].soceityName;
      this.mobileNumber = this.societyItem[0].mobileNumber;
      this.email = this.societyItem[0].email;
      this.weekday = this.societyItem[0].weekday;
      this.fromTime = this.societyItem[0].fromTime;
      this.toTime = this.societyItem[0].toTime;
       this.longitude = this.societyItem[0].longitude;
      this.lattitude = this.societyItem[0].lattitude;
      this.suspend = this.societyItem[0].suspend;
        //  this.sus = this.societyItem.suspend;
          // console.log("check2",items.suspend);


          let value = this.societyItem.map(n=>{
            return n.soceityName;

          
          })
            // this.saveSocietylist = value;


            let uniqueChars = value.filter((c, index) => {
    return value.indexOf(c) === index;
});

this.saveSocietylist = uniqueChars;
        }
      });
    },

    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.societyedit = item;
      this.soceityCode = item.soceityCode;
      this.soceityName = item.soceityName;
      this.mobileNumber = item.mobileNumber;
      this.email = item.email;
      this.weekday = item.weekday;
      this.fromTime = item.fromTime;
      this.toTime = item.toTime;
       this.longitude = item.longitude;
      this.lattitude = item.lattitude;
      this.suspend = item.suspend;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
    addSociety() {
      let soceityCode = this.soceityCode;
      let soceityName = this.soceityName;
      let mobileNumber = this.mobileNumber;
      let email = this.email;
      let contactPerson = this.contactPerson;
       let longitude = this.longitude;
      let lattitude = this.lattitude;
      let weekday = this.weekday;
      let fromTime = this.fromTime;
      let toTime = this.toTime;
      let suspend = this.suspend;
      let data = {
        soceityCode,
        soceityName,
        contactPerson,
         mobileNumber,
        email,
        weekday,
        longitude,
        lattitude,
        fromTime,
        toTime,
        suspend
      };
      APIService.saveSociety(data).then(res => {
        if (res.status == 200) {
          this.soceityCode = null;
          this.soceityName = "";
          this.contactPerson = "";
          this.email = "";
          this.mobileNumber = "";
             this.longitude = "";
          this.lattitude = "";
          this.weekday = "";
          this.fromTime = "";
          this.toTime = "";
          this.suspend = "";
          this.getSocietyList();
           Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    addRouteplus() {
      this.soceityCode = null;
          this.soceityName = "";
          this.contactPerson = "";
          this.email = "";
          this.mobileNumber = "";
            this.longitude = "";
          this.lattitude = "";
          this.weekday = "";
          this.fromTime = "";
          this.toTime = "";
          this.suspend = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      (this.EditsaveButton = true)
      return getSocietyList();
    },

    CancelRoute() {
      this.soceityCode = null;
          this.soceityName = "";
          this.contactPerson = "";
          this.email = "";
          this.mobileNumber = "";
            this.longitude = "";
          this.lattitude = "";
          this.weekday = "";
          this.fromTime = "";
          this.toTime = "";
          this.suspend = "";
      this.addButton = true;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = false;
      (this.EditsaveButton = false), this.getSocietyList();
    },
    updateRoute() {
      let id = this.societyedit._id;
     let soceityCode = this.soceityCode;
      let soceityName = this.soceityName;
      let mobileNumber = this.mobileNumber;
      let email = this.email;
      let contactPerson = this.contactPerson;
       let longitude = this.longitude;
      let lattitude = this.lattitude;
      let weekday = this.weekday;
      let fromTime = this.fromTime;
      let toTime = this.toTime;
      let suspend = this.suspend;
      let value = {
        soceityCode,
        soceityName,
        contactPerson,
         mobileNumber,
        email,
        weekday,
        longitude,
        lattitude,
        fromTime,
        toTime,
        suspend
      };
      let data = { id, value };
      APIService.societyUpdate(data).then(res => {
        if (res.status == 200) {
        this.soceityCode = null;
          this.soceityName = "";
          this.contactPerson = "";
          this.email = "";
          this.mobileNumber = "";
             this.longitude = "";
          this.lattitude = "";
          this.weekday = "";
          this.fromTime = "";
          this.toTime = "";
          this.suspend = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          this.getSocietyList();
           Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    deleteRoute() {
      const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Deleted!',
      'Your file has been deleted.',
      'success'
    )
     this.delete();
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your imaginary file is safe :)',
      'error'
    )
  }
})

    },
    delete(){
      let id = this.societyedit._id;
      let data = { id };
      APIService.societyDelete(data).then(res => {
        if (res.status == 200) {
         this.soceityCode = null;
          this.soceityName = "";
          this.contactPerson = "";
          this.email = "";
          this.mobileNumber = "";
             this.longitude = "";
          this.lattitude = "";
          this.weekday = "";
          this.fromTime = "";
          this.toTime = "";
          this.suspend = "";
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false), this.getSocietyList();
        }
      });
    }
  },
  created() {
    this.getSocietyList();
  }
};
</script>
